import { render, staticRenderFns } from "./assessment-panel-placeholder.vue?vue&type=template&id=f938ed6a&scoped=true&"
import script from "./assessment-panel-placeholder.vue?vue&type=script&lang=ts&"
export * from "./assessment-panel-placeholder.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-panel-placeholder.vue?vue&type=style&index=0&id=f938ed6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f938ed6a",
  null
  
)

export default component.exports